import type { PaywallState, SubscriptionInfo } from '@highlight/common'
import { usePaywallState } from '@renderer/chat/store/paywalls'
import { useUnifiedBilling } from '@renderer/chat/store/global-billing'
import { isPlanEnded, v2TierFor } from '@renderer/chat/utils/billingUtils'

/**
 * The billing half of what docks the meeting-hours paywall in the Meeting View. A v2
 * plan's allowance is spent and the plan can still buy more. Toasts route to
 * the view on this so they land on the paywall, not on a meeting that reads as
 * startable.
 *
 * Not `isMeetingHoursExhausted`, which mirrors the backend's brief gate and
 * exempts free and legacy plans. An ended plan gets the home Renew strip, not a
 * top-up it can't use, and a loading meter is not a verdict yet.
 */
export function isOutOfMeetingHours(paywall: PaywallState, subscription: SubscriptionInfo): boolean {
  const outOfHours = paywall.meetingHours.total !== null && paywall.meetingHours.percentage >= 100
  return !!v2TierFor(paywall.plan) && !isPlanEnded(subscription) && outOfHours && !paywall.isLoading
}

/** {@link isOutOfMeetingHours} against the live billing state. */
export function useOutOfMeetingHours(): boolean {
  const paywall = usePaywallState()
  const { subscription } = useUnifiedBilling()
  return isOutOfMeetingHours(paywall, subscription)
}
